import { Alert, Box, IconButton, Slide, Typography } from '@mui/material';
import { X } from '@phosphor-icons/react';

interface MigrationAlertProps {
  open: boolean;
  onClose: () => void;
  onAccessNewVersion: () => void;
}

export function MigrationAlert({
  open,
  onClose,
  onAccessNewVersion,
}: MigrationAlertProps) {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10000,
        width: '90%',
        maxWidth: 600,
        animation: 'slideDown 0.3s ease-out',
        '@keyframes slideDown': {
          from: {
            transform: 'translateX(-50%) translateY(-100%)',
            opacity: 0,
          },
          to: {
            transform: 'translateX(-50%) translateY(0)',
            opacity: 1,
          },
        },
      }}
    >
      <Slide direction="down" in={open} mountOnEnter unmountOnExit>
        <Alert
          severity="info"
          sx={{
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            borderRadius: 3,
            border: '1px solid #E7F0FF',
            background: '#fff',
            '& .MuiAlert-message': {
              flex: 1,
              padding: '8px 0',
              width: '100%',
            },
            '& .MuiAlert-icon': {
              fontSize: '1.5rem',
            },
          }}
        >
          <Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                mb: 0.5,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: '#3650DE',
                  flex: 1,
                  pr: 1,
                }}
              >
                Update Interface to New Version
              </Typography>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={onClose}
                sx={{
                  flexShrink: 0,
                  mt: -0.5,
                  color: '#3650DE',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                <X size={16} color="#3650DE" />
              </IconButton>
            </Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ lineHeight: 1.5 }}
            >
              This form is currently running on an older version compared to our
              new version with enhanced features, modern interface and advanced
              functionality.{' '}
              <Typography
                component="span"
                variant="body2"
                color="primary"
                sx={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  fontWeight: 600,
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    textDecoration: 'none',
                    opacity: 0.8,
                    transform: 'scale(1.02)',
                  },
                }}
                onClick={onAccessNewVersion}
              >
                Click here
              </Typography>{' '}
              to update this form to the new version to take advantage of all
              available improvements.
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                lineHeight: 1.5,
                mt: 1,
                fontStyle: 'italic',
                fontSize: '0.875rem',
                color: '#666',
              }}
            >
              ⏰ This current version will be legacy and will not be supported
              going forward
            </Typography>
          </Box>
        </Alert>
      </Slide>
    </Box>
  );
}
